/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A common estimate is about 35 ml per kilogram of body weight per day, plus extra for exercise. This calculator personalises that for you.`)
};

const es_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una estimación habitual es unos 35 ml por kilogramo de peso corporal al día, más un extra por el ejercicio. Esta calculadora lo personaliza para ti.`)
};

const de_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine gängige Schätzung liegt bei etwa 35 ml pro Kilogramm Körpergewicht und Tag, zuzüglich eines Zuschlags fürs Training. Dieser Rechner personalisiert das für dich.`)
};

const nl_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een veelgebruikte schatting is ongeveer 35 ml per kilogram lichaamsgewicht per dag, plus extra voor sport. Deze calculator personaliseert dat voor jou.`)
};

const fr_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une estimation courante est d'environ 35 ml par kilogramme de poids corporel et par jour, plus un supplément pour l'exercice. Ce calculateur le personnalise pour vous.`)
};

const it_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una stima comune è di circa 35 ml per chilogrammo di peso corporeo al giorno, più un extra per l'esercizio. Questo calcolatore lo personalizza per te.`)
};

const pt_br2_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma estimativa comum é cerca de 35 ml por quilo de peso corporal por dia, mais um extra pelo exercício. Esta calculadora personaliza isso para você.`)
};

const pt_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma estimativa comum é cerca de 35 ml por quilograma de peso corporal por dia, mais um extra para o exercício. Esta calculadora personaliza esse valor para si.`)
};

const ja_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般的な目安は体重1kgあたり1日約35mlに運動分を加えたものです。この計算機はそれをあなた向けに個別化します。`)
};

const zh_water_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一个常见估算是每千克体重每天约 35 毫升，运动时还需额外补充。本计算器会为你计算个性化数值。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const water_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.water_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("water_faq_a1", locale)
	if (locale === "en") return en_water_faq_a1(inputs)
	if (locale === "es") return es_water_faq_a1(inputs)
	if (locale === "de") return de_water_faq_a1(inputs)
	if (locale === "nl") return nl_water_faq_a1(inputs)
	if (locale === "fr") return fr_water_faq_a1(inputs)
	if (locale === "it") return it_water_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_water_faq_a1(inputs)
	if (locale === "pt") return pt_water_faq_a1(inputs)
	if (locale === "ja") return ja_water_faq_a1(inputs)
	return zh_water_faq_a1(inputs)
};